// Generated by scripts/build-heritage-rules.mjs. Edit workers/glass-shop-cart/src/heritage-rules.ts.
"use strict";
var GlassShopHeritageRules = (() => {
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __export = (target, all) => {
    for (var name in all)
      __defProp(target, name, { get: all[name], enumerable: true });
  };
  var __copyProps = (to, from, except, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key of __getOwnPropNames(from))
        if (!__hasOwnProp.call(to, key) && key !== except)
          __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
    return to;
  };
  var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

  // workers/glass-shop-cart/src/heritage-rules.ts
  var heritage_rules_exports = {};
  __export(heritage_rules_exports, {
    HERITAGE_PRICING_VERSION: () => HERITAGE_PRICING_VERSION,
    heritageSizeError: () => heritageSizeError,
    heritageSpecFromTitle: () => heritageSpecFromTitle
  });
  var HERITAGE_PRICING_VERSION = "heritage-profile-v1";
  function heritageSpecFromTitle(title) {
    const spacer = title.match(/\b([46])mm\s+Spacer\b/i);
    if (!spacer) return null;
    return {
      spacerMm: Number(spacer[1]),
      toughened: /toughened/i.test(title) && !/\(Float\)/i.test(title)
    };
  }
  function heritageSizeError(width, height, spec) {
    if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) {
      return "Please enter valid positive dimensions in millimetres.";
    }
    if (!spec || ![4, 6].includes(spec.spacerMm)) {
      return "This Heritage specification needs checking. Please contact us.";
    }
    if (width < 100 || height < 100) {
      return "Minimum dimension for heritage units is 100mm.";
    }
    const square = spec.spacerMm === 6 ? 1e3 : 600;
    const short = spec.spacerMm === 6 ? 800 : 500;
    const long = spec.spacerMm === 6 ? 1600 : 1e3;
    const fits = width <= square && height <= square || width <= short && height <= long || height <= short && width <= long;
    if (!fits) {
      return `Maximum size for ${spec.spacerMm}mm spacer heritage units is ${square}x${square}mm or ${short}x${long}mm.`;
    }
    if (spec.toughened && !(width >= 150 && height >= 250 || height >= 150 && width >= 250)) {
      return "Minimum size for toughened heritage units is 150x250mm. Please contact us for smaller float units.";
    }
    return null;
  }
  return __toCommonJS(heritage_rules_exports);
})();
